export default "__VITE_ASSET__DjC_RMAl__"